import { Form } from '@sinohealth/butterfly-ui-components/lib';
import { getPasswordChecks } from '@/utils/passwordPolicy';

export default function PasswordStrength({ value = '' }: { value?: string }) {
  const checks = getPasswordChecks(value);
  const items = [
    ['长度 ≥ 10 位', checks.length],
    ['含字母', checks.letter],
    ['含数字', checks.number],
    ['含符号', checks.symbol],
  ] as const;
  return (
    <div
      aria-live="polite"
      style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 12px', fontSize: 12, margin: '8px 0' }}
    >
      {items.map(([label, passed]) => (
        <span key={label} style={{ color: passed ? '#52a882' : '#969ca8' }}>
          {passed ? '✓' : '○'} {label}
        </span>
      ))}
      {value.length > 20 && (
        <span style={{ flexBasis: '100%', color: '#ff4d4f' }}>密码不能超过 20 位</span>
      )}
    </div>
  );
}
export function PasswordStrengthField({ name }: { name: string }) {
  return (
    <Form.Item noStyle shouldUpdate={(prev, next) => prev[name] !== next[name]}>
      {({ getFieldValue }) => <PasswordStrength value={getFieldValue(name) || ''} />}
    </Form.Item>
  );
}
